const old = window.__PROOF_RUNTIME_CONFIGURATION__ as { marketingSegmentId: string };
window.__PROOF_RUNTIME_CONFIGURATION__ = Object.freeze({
  ...old,
  segmentId: old.marketingSegmentId,
});
